export const CLINICAL_REVIEW_CATEGORIES = {
  POM: "POM",
  PMED: "PMed",
  ID_CHECK: "id-check",
  PREAPPROVED_PRODUCT: "preapprovedproduct",
  GSL: "GSL",
  VACCINE: "VACCINE",
} as const;

export type ClinicalReviewCategory =
  (typeof CLINICAL_REVIEW_CATEGORIES)[keyof typeof CLINICAL_REVIEW_CATEGORIES];

export const CLINICAL_REVIEW_CATEGORY_LIST = Object.values(
  CLINICAL_REVIEW_CATEGORIES,
) as ClinicalReviewCategory[];

export const CLINICAL_REVIEW_POM_CATEGORY = CLINICAL_REVIEW_CATEGORIES.POM;
export const CLINICAL_REVIEW_PMED_CATEGORY = CLINICAL_REVIEW_CATEGORIES.PMED;
export const CLINICAL_REVIEW_ID_CHECK_CATEGORY =
  CLINICAL_REVIEW_CATEGORIES.ID_CHECK;
export const CLINICAL_REVIEW_PREAPPROVED_PRODUCT_CATEGORY =
  CLINICAL_REVIEW_CATEGORIES.PREAPPROVED_PRODUCT;
export const CLINICAL_REVIEW_GSL_CATEGORY = CLINICAL_REVIEW_CATEGORIES.GSL;
export const CLINICAL_REVIEW_VACCINE_CATEGORY =
  CLINICAL_REVIEW_CATEGORIES.VACCINE;

export const CLINICAL_REVIEW_SPECIAL_CATEGORIES = [
  CLINICAL_REVIEW_ID_CHECK_CATEGORY,
  CLINICAL_REVIEW_PREAPPROVED_PRODUCT_CATEGORY,
] as const;

export type ClinicalReviewSpecialCategory =
  (typeof CLINICAL_REVIEW_SPECIAL_CATEGORIES)[number];

export const CLINICAL_REVIEW_NON_REVIEW_TAG_CATEGORIES = [
  CLINICAL_REVIEW_GSL_CATEGORY,
  CLINICAL_REVIEW_VACCINE_CATEGORY,
] as const;

export type ClinicalReviewNonReviewTagCategory =
  (typeof CLINICAL_REVIEW_NON_REVIEW_TAG_CATEGORIES)[number];

export type ClinicalReviewRouteCategory = Exclude<
  ClinicalReviewCategory,
  ClinicalReviewNonReviewTagCategory
>;

export const isClinicalReviewSpecialCategory = (
  category?: string,
): category is ClinicalReviewSpecialCategory =>
  !!category &&
  (CLINICAL_REVIEW_SPECIAL_CATEGORIES as readonly string[]).includes(category);

export const isClinicalReviewNonReviewTagCategory = (
  category?: string,
): category is ClinicalReviewNonReviewTagCategory =>
  !!category &&
  (CLINICAL_REVIEW_NON_REVIEW_TAG_CATEGORIES as readonly string[]).includes(
    category.toUpperCase(),
  );

export const CLINICAL_REVIEW_STATUSES = {
  COMPLETED: "COMPLETED",
  AWAITING_REVIEW: "AWAITING_REVIEW",
  AWAITING_ID_CHECK: "AWAITING_ID_CHECK",
  ID_CHECK_COMPLETED: "ID_CHECK_COMPLETED",
  PREAPPROVED_PRODUCT: "PREAPPROVEDPRODUCT",
} as const;

export type ClinicalReviewStatus =
  (typeof CLINICAL_REVIEW_STATUSES)[keyof typeof CLINICAL_REVIEW_STATUSES];

export const CLINICAL_REVIEW_DEFAULT_ASC_SORT_STATUSES = [
  CLINICAL_REVIEW_STATUSES.AWAITING_REVIEW,
  CLINICAL_REVIEW_STATUSES.AWAITING_ID_CHECK,
] as const;

export const usesAscendingSortByDefault = (
  status: ClinicalReviewStatus,
): boolean =>
  (CLINICAL_REVIEW_DEFAULT_ASC_SORT_STATUSES as readonly string[]).includes(
    status,
  );
